<template>
	<div class="colorgroup" :class="{colorflexleft:isleft}">
		<div class="bigball" :class="{active:coloridx===index,whiteactive:tentotwo(item.enc_color)==='ffffff'&&tentotwo(item.start_color)==='ffffff'}"
		 v-for="(item,index) in color" :key="item.color_name" :style="{borderColor:'#'+tentotwo(item.enc_color)}"
		 @click="setidx(index)">
			<div class="ball" :style="{backgroundImage:'linear-gradient(to bottom,#'+tentotwo(item.start_color)+',#'+tentotwo(item.enc_color)+')'}">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'colorSel',
		props: {
			color: {
				type: Array,
				default: () => []
			},
			coloridx: {
				type: Number,
				default: 0
			},
			isleft: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			setidx(idx) {
				console.log(idx)
				if (this.coloridx !== idx) {
					this.$emit('onSetidx', idx)
				}
			},
			tentotwo(num){
				return num.toString(16).padStart(6,0)
			}
		}
	}
</script>

<style scoped>
	.colorgroup {
		display: flex;
		display: -webkit-flex;
		height: .45rem;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0 .1rem;
	}

	.colorflexleft {
		justify-content: flex-start !important;
	}

	.bigball {
		display: flex;
		display: -webkit-flex;
		justify-content: center;
		align-items: center;
		width: .32rem;
		height: .32rem;
		box-sizing: border-box;
		margin: 0 .09rem;
		flex-shrink: 0;
		border: .01rem solid;
		border-radius: 50%;
	}

	.ball {
		width: .24rem;
		height: .24rem;
		border-radius: 50%;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		justify-content: center;
		transition: transform 0s linear;
	}

	.active .ball::after {
		display: block;
		content: '';
		width: .16rem;
		height: .16rem;
		background-image: url("~@/assets/check.png");
		background-position: center;
		background-size: cover;
	}
	.whiteactive{
		border-color:#F8F8F8!important;
	}
	.active.whiteactive .ball{
		border:1px solid #F8F8F8!important;
	}
	.whiteactive .ball::after {
		background-image: url("~@/assets/wcheck.png");
	}

	.active .ball {
		transform: scale(1.5);
		transition: transform 0.1s linear;
	}

	.active {
		border: none;
	}
</style>
